import { Product, DataProduct, LocalCurrency, Inventories, Category, Store } from "../types";
import HttpClientRequest from "../api/client-request";
export default class ProductService {

    static async getProducts(requestId?: string): Promise<Product[]> {
        try {
            
            const response = await HttpClientRequest.doGetRequest('/customer/products', {}, requestId);

            if (response.status === 200) {

                const products: Product[] = (response.data||[]).map((product: DataProduct) => {
                    const productImage = product.productImages.find(image => image.featured);
                    return { 
                        ...product, 
                        currency: LocalCurrency.naira,  
                        applyDiscount: product.inventories[0].applyDiscount,
                        discountPrice: product.inventories[0].discountPrice,
                        price: product.inventories[0].basePrice,
                        discountType: product.inventories[0].discountType,
                        basePrice: product.inventories[0].basePrice,
                        qtyInStock: product.inventories.reduce((acc: number, curr: Inventories) => acc + curr.qtyInStock , 0),
                        image: productImage ? productImage.image : ''
                    } as Product
                })


                return products;
            }

            return [];

        } catch (error) {
            console.error("Error fetching products:", error);
            return [];
        }
    }
    
    static async getCategories(requestId?: string): Promise<Category[]> {
        try {
            
            const response = await HttpClientRequest.doGetRequest('/customer/categories', {}, requestId);

            if (response.status === 200) {
                return response.data;
            }

            return [];

        } catch (error) {
            console.error("Error fetching products:", error);
            return [];
        }
    }
    
    static async getStores(requestId?: string): Promise<Store[]> {
        try {
            
            const response = await HttpClientRequest.doGetRequest('/customer/active-stores', {}, requestId);

            if (response.status === 200) {
                return response.data;
            }

            return [];

        } catch (error) {
            console.error("Error fetching products:", error);
            return [];
        }
    }
}